import { render, staticRenderFns } from "./square-trash.vue?vue&type=template&id=6f50991d&"
import script from "./square-trash.vue?vue&type=script&lang=js&"
export * from "./square-trash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports